import { Text } from '@/components/atoms/text';
import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled(Text)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const StyledPageLayoutHeader = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2.8, 0),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
  },
}));

export const StyledPageLayoutHeaderActions = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 3),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0),
  },
}));

export const BackButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0),
}));
